import { render, staticRenderFns } from "./TeamsCardTable.vue?vue&type=template&id=5494b54a&lang=pug"
import script from "./TeamsCardTable.vue?vue&type=script&lang=js"
export * from "./TeamsCardTable.vue?vue&type=script&lang=js"
import style0 from "./TeamsCardTable.vue?vue&type=style&index=0&id=5494b54a&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports